const { addEventListener } = require("@/helpers/clickManager");

export class IdleManager {
  isIdle = true;
  idleTimeout;
  idleTimeLimit = 650;
  constructor() {
    if (IdleManager.instance) {
      return IdleManager.instance; // Return the existing instance
    }

    IdleManager.instance = this; // Store the instance

    addEventListener(null, "mousedown", () => {
      clearTimeout(this.idleTimeout);
      this.setIdleState(false);
    });
    addEventListener(null, "mouseup", () => {
      this.resetIdleTimer();
    });
    addEventListener(null, "keydown", () => {
      clearTimeout(this.idleTimeout);
      this.setIdleState(false);
    });
    addEventListener(null, "keyup", () => {
      this.resetIdleTimer();
    });
  }

  setIdleState(state) {
    this.isIdle = state;
  }

  getIdleState() {
    return this.isIdle;
  }

  // Reset the idle timer
  resetIdleTimer() {
    // Clear the existing timeout and set a new one
    clearTimeout(this.idleTimeout);
    this.idleTimeout = setTimeout(
      this.setIdleState.bind(this),
      this.idleTimeLimit,
      true,
    );
  }
}
